<template>
  <div class="mb-12">
    <div class="mb-12">
      <label>
        In Honor Of...
        <span class="text-sm font-sans-book block">
          Would you like to host your event in honor of someone (or something)?
        </span>
      </label>
      <div class="group__radio">
        <div class="flex flex-wrap select-box">
          <label class="w-full text-base font-normal md:w-1/2 md:pr-3">
            <input v-model="isInHonorOfForm" name="honorOf" type="radio" :value="false">
            <span class="inline-block mr-2 radio"></span> No
          </label>

          <label class="w-full text-base font-normal md:w-1/2 md:pr-3">
            <input v-model="isInHonorOfForm" name="honorOf" type="radio" :value="true">
            <span class="inline-block mr-2 radio"></span> Yes
          </label>
        </div>
      </div>
    </div>
    <div v-show="isInHonorOfForm">
      <div class="mb-12">
        <label for="iho-name">
          Name <span class="text-red">*</span>
          <span class="text-sm font-sans-book block">
            Who (or what) do you want to honor? If you have multiple honorees, please separate using commas.
          </span>
        </label>
        <input
          id="iho-name"
          v-model="inHonorOfNameForm"
          name="in memory of name"
          v-validate="`${isInHonorOfForm ? 'required|' : ''}max:60`"
          type="text"
        />
        <span v-show="errors.has('in memory of name')" class="text-lg error text-error-red">{{ errors.first('in memory of name') }}</span>
      </div>
      <div class="mb-12">
        <label for="iho-photo">
          Photo
          <span class="text-sm font-sans-book block">
             If you have multiple honorees, please use one photo to represent them.
          </span>
        </label>
        <direct-upload-player v-model="inHonorOfPhotoForm" id="iho-photo" />
      </div>
      <div class="mb-12">
        <label for="iho-description">
          Description <span class="text-red">*</span>
          <span class="text-sm font-sans-book block">
             Tell registrants more about who (or what) you are honoring, and why.
          </span>
        </label>
        <textarea
          style="height:12rem"
          id="iho-description"
          v-model="inHonorOfDescriptionForm"
          name="in memory of description" type="text"
          v-validate="`${isInHonorOfForm ? 'required' : ''}`"
        />
        <span v-show="errors.has('in memory of description')" class="text-lg error text-error-red">
          {{ errors.first('in memory of description') }}
        </span>
      </div>
      <hr class="border-b border-gray-medium" />
    </div>
  </div>
</template>

<script>
import ImageOverlay from "../../images/ImageOverlay.vue";
import DirectUploadPlayer from "../../images/DirectUploadPlayer.vue";
const masterType = {
  type: [String, Boolean],
  required: true,
};

const masterFnType = {
  type: Function,
  required: true,
}

function getterSetter(key) {
  return {
    get() {
      return this[key]
    },
    set(val) {
      this[`${key}Change`](val);
    }
  }
}

export default {
  name: "HonorOfManager",
  components: {DirectUploadPlayer, ImageOverlay},
  props: {
    isInHonorOf: masterType,
    inHonorOfName: masterType,
    inHonorOfPhoto: masterType,
    inHonorOfDescription: masterType,
    isInHonorOfChange: masterFnType,
    inHonorOfNameChange: masterFnType,
    inHonorOfPhotoChange: masterFnType,
    inHonorOfDescriptionChange: masterFnType,
    isValidChange: masterFnType,
  },
  data() {
    return {
      file: null,
      upload: {
        active: false,
        percent: 0,
        key: '',
        url: '',
        preview: '',
      }
    }
  },
  computed: {
    isInHonorOfForm: getterSetter('isInHonorOf'),
    inHonorOfNameForm: getterSetter('inHonorOfName'),
    inHonorOfDescriptionForm: getterSetter('inHonorOfDescription'),
    inHonorOfPhotoForm: getterSetter('inHonorOfPhoto')
  },
  watch: {
    isInHonorOfForm() {
      if (!this.isInHonorOfForm) {
        this.isValidChange(true);
      }
    }
  },
  methods: {
    handleFileChange(e) {
      let files = e.target.files || e.transfer.files;

      if (!files.length) {
        return;
      }

      this.readFile(files[0]);
    },
    async readFile(file) {
      if (this.upload.active) {
        return true;
      }

      this.upload.preview = URL.createObjectURL(file);

      this.upload.active = true;
      this.isValidChange(false);

      const valid = await this.$validator.validateAll();

      if (!valid) {
        this.upload.active = false;
        return;
      }

      this.file = file;

      const query = {
        file_size: file.size,
        file_type: file.type,
        file_name: file.name,
        file_ext: file.name.split('.').reverse()[0],
      };

      try {
        const { data: { url, key } } = await axios.post(this.$laroute.route('uploads.direct.url'), query);

        await axios.put(url, file, {
          headers: { 'Content-Type': file.type },
          onUploadProgress: progressEvent => {
            this.upload.percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          },
          withCredentials: false
        });
        this.inHonorOfPhotoChange(key);
        this.isValidChange(true);
      } catch (e) {
        if (e.request && e.request.response) {
          const errName = 'in memory of photo'
          e.response.data.errors.file_name && this.errors.add({
            field: errName,
            msg: e.response.data.errors.file_name[0]
          });
          e.response.data.errors.file_size && this.errors.add({
            field: errName,
            msg: e.response.data.errors.file_size[0]
          });
          e.response.data.errors.file_type && this.errors.add({
            field: errName,
            msg: e.response.data.errors.file_type[0]
          });
        }
      }

      this.upload.active = false;
    }
  }
}
</script>

<style scoped>
  img {
    max-height: 12rem;
  }
</style>
